module.exports = __webpack_public_path__ + "static/media/_MIC2427.image.26c5c1de.png";